import { useState } from "react";

// eslint-disable-next-line import/prefer-default-export
export const useForm = (initialState) => {
  /*
  initialState object should should look like: 
  {
    key: {
      title: string,
      value: string or boolean - initial value,
      type: ('text'|'checkbox'|'select'|'singlecheckbox'|'multivalueCheckbox'|'textarea') - optional(defaults to text),
      htmlObj: JSX code - optional(when inputted, replaces title),
      mandatory: boolean - optional(defaults to false),
      dependOn: Array(string) - optional - keys of the fields that have evaluate to true in order to show this field,
      hint: string - optional - when passed in, '?' icon will appear which upon hover will display the string,
      checkboxText1 - optional - 
      checkboxText2 - optional - replace YES and NO texts respectively when type === checkbox
      selectOptions: Array({value: string, label: string}) - optional - options when type === select
      radioOptions: Array(value: string) - optional - options when type === radio
    }
  } */
  const [state, setState] = useState(initialState);
  const handleChange = (key, value) => {
    if (Array.isArray(key)) {
      let updates = {};
      key.forEach((k) => {
        updates = {
          ...updates,
          [k]: { ...state[k], value },
        };
      });
      setState({
        ...state,
        ...updates,
      });
    } else {
      setState({
        ...state,
        [key]: { ...state[key], value },
      });
    }
  };
  return [state, handleChange];
};

/* function used to convert first argument from useForm to an object with values only */
export const formCreatorConvertToValues = (fields) => {
  const iterableObj = Object.entries(fields)
    .filter(([, elem]) => Object.prototype.hasOwnProperty.call(elem, "value"))
    .map(([key, elem]) => [key, elem.value]);
  const objectFromEntries = iterableObj.reduce((acc, [key, val]) => {
    acc[key] = val;
    return acc;
  }, {});
  return objectFromEntries;
};

export const isEmpty = (val) => typeof val === "undefined" || val === null;

export const getField = (data) => (fieldName) =>
  !isEmpty(data[fieldName]) ? data[fieldName] : "";

export const getVal = (initialData) => getField(initialData);

/**
 * Pass the state values & set function => renderfield will pass the value, key and index of each field
 * @param {*} state
 * @param {*} setState
 * @returns
 */
export const setValue = (state, setState) => (value, key, i) => {
  const mappedState = state.map((el, index) => {
    if (i === index) {
      return { ...el, [key]: value };
    }
    return el;
  });
  setState(mappedState);
};

/**
 * Pass the state values & set function => the field will handle the repeated click to remove last row
 * @param {*} state
 * @param {*} setState
 * @returns
 */
export const removeLast = (state, setState) => () => {
  const newArr = [...state];
  newArr.splice(newArr.length - 1);
  setState(newArr);
};

/**
 * Pass state values, state set function and the intial state object for new rows
 * @param {*} state
 * @param {*} setState
 * @param {*} initObj
 * @returns
 */
export const addRow = (state, setState, initObj) => () =>
  setState([
    ...state,
    {
      ...initObj,
    },
  ]);
